import { GROSS_BALANCE_LABEL } from '../../../../utils/fundStatementLabels';
import type { UnsplitFigures } from '../../../../types/dealerFundStatementPeriod.types';
import { FigureCell } from './FigureCell';
import { LABEL_SPAN_TO_GROSS, LABEL_SPAN_TO_NET, STATEMENT_GRID } from './statementGrid';
import { UnsplitBadge } from './UnsplitBadge';

interface Props {
    label: string;
    net: string;
    gross: string;
    unsplit: UnsplitFigures;
    currency: string;
    emphasised?: boolean;
}

export function BalanceRows({ label, net, gross, unsplit, currency, emphasised = false }: Props) {
    const tint = emphasised ? 'border-t border-mp-border bg-mp-surface py-1' : '';
    return (
        <dl className="space-y-1">
            <div className={`${STATEMENT_GRID} text-sm font-semibold ${tint}`}>
                <dt className={`flex flex-wrap items-center gap-2 ${LABEL_SPAN_TO_NET}`}>
                    <span>{label}</span>
                    {unsplit.postings > 0 && <UnsplitBadge postings={unsplit.postings} />}
                </dt>
                <FigureCell column="Net" value={net} currency={currency} />
            </div>
            <div className={`${STATEMENT_GRID} text-xs text-mp-muted`}>
                <dt className={`pl-4 ${LABEL_SPAN_TO_GROSS}`}>{GROSS_BALANCE_LABEL}</dt>
                <FigureCell column="Gross" value={gross} currency={currency} />
            </div>
        </dl>
    );
}
